import config from '../../../../config';
import { TachoModule } from '../../../domainModels/modules/TachoModule';
import { axiosInstance as axios } from '../../axios/axiosInstance';

export const modulesEndpoint = `${config.tachoAPI.url}/TachoModules`;

export const getModules = (): Promise<Array<TachoModule>> => {
    return axios
        .get<Array<TachoModule>>(modulesEndpoint)
        .then(response => {
            return response.data;
        })
        .catch(err => {
            throw Error(getModules.name + err);
        });
};
